var path = 'areas/shared/views/selector/select-multiple.html';
var html = "<!DOCTYPE html> <html lang=en> <head> <meta charset=UTF-8> <title>Title</title> </head> <body> </body> </html>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/areas/shared/views/selector/select-multiple.html
// module id = 976
// module chunks = 1